import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import { COLORS, SPACING, SHADOWS } from "../../constants/theme";

const NAV_ITEMS = [
  {
    label: "Playground",
    icon: "play",
    path: "/playground",
  },
  {
    label: "Instructions",
    icon: "cog",
    path: "/system-messages",
  },
];

const COLLAPSED_WIDTH = 52;
const EXPANDED_WIDTH = 220;

const PlaygroundSidebar = () => {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const leaveTimer = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(leaveTimer.current);
    setExpanded(true);
  };

  const handleMouseLeave = () => {
    leaveTimer.current = setTimeout(() => {
      setExpanded(false);
    }, 120);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        position: "relative",
        width: COLLAPSED_WIDTH,
        minWidth: COLLAPSED_WIDTH,
        zIndex: 200,
        overflow: "visible",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
          transition: "width 0.22s cubic-bezier(0.4,0,0.2,1)",
          backgroundColor: COLORS.white,
          borderRight: `1px solid ${COLORS.border}`,
          boxShadow: expanded ? SHADOWS.lg : "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          overflow: "hidden",
        }}
      >
      {/* Nav items */}
      <div style={{ display: "flex", flexDirection: "column", paddingTop: SPACING.md }}>
        {NAV_ITEMS.map((item) => {
          const active = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              title={!expanded ? item.label : undefined}
              style={{
                display: "flex",
                alignItems: "center",
                gap: SPACING.sm,
                padding: `${SPACING.sm}px ${SPACING.md}px`,
                border: "none",
                background: active ? COLORS.primaryWeak : "transparent",
                cursor: "pointer",
                borderLeft: active ? `3px solid ${COLORS.primary}` : "3px solid transparent",
                borderRadius: 0,
                textAlign: "left",
                width: "100%",
                transition: "background 0.15s",
                minHeight: 44,
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => {
                if (!active) e.currentTarget.style.background = COLORS.hover;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = active ? COLORS.primaryWeak : "transparent";
              }}
            >
              <McIcon
                icon={item.icon}
                size="24"
                color={active ? COLORS.primary : COLORS.gray}
                style={{ display: "inline-flex", minWidth: 24, justifyContent: "center", flexShrink: 0 }}
              />
              <span
                className={active ? "mds-text--small-bold" : "mds-text--small-normal"}
                style={{
                  color: active ? COLORS.primary : COLORS.text,
                  opacity: expanded ? 1 : 0,
                  transition: "opacity 0.15s",
                  pointerEvents: "none",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </span>
            </button>
          );
        })}

      </div>
      </div>
    </div>
  );
};

export default PlaygroundSidebar;
